import { render, staticRenderFns } from "./product.modal.vue?vue&type=template&id=e55c15b8&scoped=true&"
import script from "./product.modal.vue?vue&type=script&lang=js&"
export * from "./product.modal.vue?vue&type=script&lang=js&"
import style0 from "./product.modal.vue?vue&type=style&index=0&id=e55c15b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55c15b8",
  null
  
)

export default component.exports